/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// any CSS you import will output into a single css file
import './scss/backend.scss';

import '../../vendor/ohmediaorg/backend-bundle/assets/js/index.js';

import PaySafe  from '../frontend/js/modules/paysafe.js';
window.PaySafe = PaySafe;
